import { mediaMax } from "components/designV2/breakpoints";
import { Spacing } from "components/designV2/constants";
import { ColorV2 } from "config/colors";
import styled from "styled-components";

export const RowCard = styled.button<{ $isInactive: boolean }>`
  width: 100%;
  padding: 12px 16px;
  border-radius: 16px;
  background: ${ColorV2.White};
  border: 1px solid transparent;
  text-align: left;
  font: inherit;
  cursor: pointer;
  opacity: ${(props) => (props.$isInactive ? 0.6 : 1)};

  &:hover {
    border-color: ${ColorV2.Blue6};
  }

  &:focus-visible {
    outline: 2px solid ${ColorV2.Blue1};
    outline-offset: 2px;
  }
`;

export const RowGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(200px, 2fr) repeat(5, minmax(80px, 1fr)) auto;
  column-gap: 10px;
  align-items: center;
  width: 100%;

  ${mediaMax.desktop} {
    display: flex;
    flex-direction: column;
    gap: ${Spacing.sm}px;
  }
`;

export const RowTop = styled.div`
  display: contents;

  ${mediaMax.desktop} {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
`;

export const AvatarAndActions = styled.div`
  order: 100;
  display: flex;
  align-items: center;

  ${mediaMax.desktop} {
    order: unset;
  }
`;

export const RowMetrics = styled.div`
  display: contents;

  ${mediaMax.desktop} {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: ${Spacing.md}px ${Spacing.sm}px;
    width: 100%;
  }
`;
